import React from 'react';
import {withRouter} from 'react-router-dom';
import ImageSlides from 'react-imageslides';
import Zoomable from 'react-instagram-zoom';


class Image extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            galleryShow: false
        }
    }

    _handleImageClick = () => {
        const {history, src} = this.props;
        history.push({
            pathname: '/app/imageSlide',
            //search: `?lessonId=${id}`,
            state: {src: src}
        });
    };

    render() {
        const {galleryShow} = this.state;
        const {alt, src, style} = this.props;

        /*return (
            <>
                <img src={src} alt={alt} style={style} onClick={() => this.setState({galleryShow: true})}/>

                {galleryShow &&
                <div style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    zIndex: 999999999,
                    backgroundColor: '#fff'
                }}>
                    <Zoomable releaseAnimationTimeout={999999999}>
                        <img src={src} alt={alt} style={style} onClick={() => this.setState({galleryShow: true})}/>
                    </Zoomable>
                </div>
                }
            </>
        )*/

        return (
            <img src={src} alt={alt} style={style} onClick={this._handleImageClick}/>
        );
    }
}

export default withRouter(Image);
